import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { Pos } from '@shop/const';

@Component({
  selector: 'sd-pickup-shop-list-desktop-single',
  templateUrl: './pickup-shop-list-desktop-single.component.html',
  styleUrls: ['./pickup-shop-list-desktop-single.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPickupShopListDesktopSingleComponent {
  @Input() shop: Pos;

  @Output() back = new EventEmitter<void>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() select = new EventEmitter<void>();

  iconType = CUSTOM_ICON_TYPE;

  onBack(): void {
    this.back.emit();
  }

  onSelect(): void {
    this.select.emit();
  }
}
